export const FileTypes = {
  IMAGE: "image/*",
  VIDEO: "video/*",
  AUDIO: "audio/*",
  DOCUMENT: "application/pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx",
};

export const API_URL = 'https://halo365-bare.us-east-1.elasticbeanstalk.com:445';
